import browser from './browser';
import loadPage from './loadPage';

export { browser, loadPage };
